import React from "react"
// import ReactDOM from "react-dom/client"
import { Provider } from "react-redux"
import { GatsbyBrowser } from "gatsby"
import { getChatbotTreatment } from "./src/utils/split_utils"
// redux
import { store } from "./src/store/store"

// @ts-ignore
import * as buttonStyles from "@eventbrite/marmalade/lib/components/Button/Button.css"
// @ts-ignore
import * as checkboxStyles from "@eventbrite/marmalade/lib/components/Checkbox/Checkbox.css"
// @ts-ignore
import * as choiceCardStyles from "@eventbrite/marmalade/lib/components/ChoiceCard/ChoiceCard.css"
// @ts-ignore
import * as choiceListStyles from "@eventbrite/marmalade/lib/components/ChoiceList/ChoiceList.css"
// @ts-ignore
import * as inlineAlertStyles from "@eventbrite/marmalade/lib/components/InlineAlert/InlineAlert.css"
// @ts-ignore
import * as radioStyles from "@eventbrite/marmalade/lib/components/Radio/Radio.css"
// @ts-ignore
import * as textAreaStyles from "@eventbrite/marmalade/lib/components/TextArea/TextArea.css"
// @ts-ignore
import * as textFieldStyles from "@eventbrite/marmalade/lib/components/TextField/TextField.css"
// @ts-ignore
import * as selectFieldStyles from "@eventbrite/marmalade/lib/components/SelectField/SelectField.css"
// @ts-ignore
import * as formControlStyles from "@eventbrite/marmalade/lib/components/FormControl/FormControl.css"
// @ts-ignore
import * as iconStyles from "@eventbrite/marmalade/lib/components/Icon/Icon.css"
// @ts-ignore
import * as stackStyles from "@eventbrite/marmalade/lib/components/Layout/Stack/Stack.css"
// @ts-ignore
import * as typographyStyles from "@eventbrite/marmalade/lib/components/Typography/Typography.css"
import { setMetaData } from "./src/store/slices/metadata.slice"

export const wrapRootElement: GatsbyBrowser["wrapRootElement"] = ({
  element
}) => {
  return (
    <Provider
      store={store}
      // @ts-ignore
      styles={{
        choiceCardStyles,
        buttonStyles,
        checkboxStyles,
        inlineAlertStyles,
        choiceListStyles,
        textAreaStyles,
        textFieldStyles,
        radioStyles,
        formControlStyles,
        selectFieldStyles,
        iconStyles,
        stackStyles,
        typographyStyles
      }}
    >
      {element}
    </Provider>
  )
}

export const onRouteUpdate: GatsbyBrowser["onRouteUpdate"] = ({ location }) => {
  if (typeof window !== "undefined") {
    if (location?.pathname && window?.duet?.setMetadata) {
      window.duet.setMetadata({
        updated_url: location.pathname
      })
    }
  }
}

export const onInitialClientRender: GatsbyBrowser["onInitialClientRender"] =
  () => {
    window.CXoneDfo = "cxone"

    //Fetch Split treatment in background(non - blocking)
    getChatbotTreatment()
      .then(treatment => {
        store.dispatch(setMetaData({
          chatbotTreatmentEnabled: treatment,
          chatbotTreatmentLoaded: true
        }))

        process.env.GATSBY_DEBUG === "true" &&
          console.log('Split treatment loaded:', treatment)
      })
      .catch(error => {
        process.env.GATSBY_DEBUG === "true" &&
          console.warn('Failed to load Split treatment:', error)

        // Fallback to enabled on error
        store.dispatch(setMetaData({
          chatbotTreatmentEnabled: true,
          chatbotTreatmentLoaded: true
        }))
      })
  }


